export class Settings {
    defaultTheme = 'default';
    activeTheme = 'default';
}